import React, { useEffect, useState } from "react";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import { useAuth } from "../../navigation/Auth/ProvideAuth";
import jwt_decode from "jwt-decode";
import { getEventPlaceLocations } from "../../services/eventPlaceServices";
import { getEventPersonnelsForChef, updateEventSupplierPersonnel } from "../../services/eventPersonnelServices";

export const ChefPersonnelAssign = () => {
    const user = useAuth();
    const encodedJwt = jwt_decode(user.token);
    const [personnelList, setPersonnelList] = useState([]);
    const [state, setState] = useState({ locations: [] });
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [vestNo, setVestNo] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // document.body.style.overflow = 'hidden';
        getData();

        var oldLocationId = 0;
        var oldItem = localStorage.getItem('eventlocationdata');
        if (oldItem != null) { oldLocationId = JSON.parse(oldItem).eventPlaceLocationId; }
        var setJwtValue = true;
        if (encodedJwt.events[0].eventPlaceLocationId == null || (oldItem && oldLocationId > 0 && oldLocationId != encodedJwt.events[0].eventPlaceLocationId)) {
            if (oldItem) {
                var oldItemJson = JSON.parse(oldItem);
                if (oldItemJson.uniqueKey == encodedJwt.events[0].eventUniqueKey) {
                    setJwtValue = false;
                    setSelectedLocation(oldItemJson.eventPlaceLocationId);
                    setPhoneNumber(oldItemJson.phoneNumber);
                }
            }
        }
        if (setJwtValue) {
            setSelectedLocation(encodedJwt.events[0].eventPlaceLocationId);
            setPhoneNumber(encodedJwt.events[0].phoneNumber);
        }
    }, []);

    const getData = () => {
        getEventPlaceLocations(encodedJwt.events[0].eventPlaceId).then((res) => {
            getEventPersonnelsForChef(encodedJwt.events[0].uniqueKey).then((res2) => {
                setState({ locations: res });
                setPersonnelList(res2);
            });
        });
    };

    const saveForm = () => {
        setLoading(true);
        updateEventSupplierPersonnel({
            uniqueKey: encodedJwt.events[0].uniqueKey,
            locationId: selectedLocation,
            phoneNumber: phoneNumber,
        }).then((res) => {
            localStorage.setItem('eventlocationdata', JSON.stringify({ uniqueKey: encodedJwt.events[0].eventUniqueKey, eventPlaceLocationId: selectedLocation, phoneNumber: phoneNumber }));
            notification.success({ message: "Bilgileriniz başarıyla güncellendi" });
        }).catch((err) => {
            notification.error({ message: "Bilgileriniz güncellenirken hata oluştu" });
        }).finally(() => {
            setLoading(false);
        });
    };

    const saveAddForm = () => {
        if (selectedLocation == null) {
            notification.error({ message: "Lütfen bilgilerinizi güncelleyiniz." });
            return;
        }
        if (vestNo == "" || vestNo == null || vestNo == "0")
            return;
        setLoading(true);
        updateEventSupplierPersonnel({
            vestNo: vestNo,
            locationId: selectedLocation,
            eventUniqueKey: encodedJwt.events[0].eventUniqueKey,
        }).then((res) => {
            notification.success({ message: "Personel başarıyla eklendi" });
            setVestNo("");
            getData();
        }).catch((err) => {
            notification.error({ message: "Personel eklerken hata oluştu" });
        }).finally(() => {
            setLoading(false);
        });
    };

    const onDeleteConfirm = (uniqueKey) => {
        setLoading(true);
        updateEventSupplierPersonnel({
            uniqueKey: uniqueKey,
            locationId: null,
            phoneNumber: '',
        }).then((res) => {
            notification.success({ message: "Personel başarıyla silindi" });
            getData();
        }).catch((err) => {
            notification.error({ message: "Personel silinirken hata oluştu" });
        }).finally(() => {
            setLoading(false);
        });
    };

    const onExit = () => {
        window.localStorage.clear();
        window.location.reload();
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white dark:bg-gray-900 rounded-lg p-6 flex items-center gap-3 shadow-lg">
                        <svg className="animate-spin h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span className="text-gray-700 dark:text-gray-300 font-medium">Yükleniyor...</span>
                    </div>
                </div>
            )}
            <div className="max-w-3xl mx-auto px-4 py-6">
                <div className="mb-6">
                    <div className="text-lg font-semibold text-gray-800">ETKİNLİK PERSONEL YOKLAMA</div>
                    <div className="text-sm text-gray-600">{encodedJwt.events[0].eventName}</div>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-4">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Lokasyon</label>
                            <select
                                value={selectedLocation || ""}
                                onChange={(e) => setSelectedLocation(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                            >
                                <option value="">Lokasyon Seçiniz</option>
                                {state.locations.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Telefon Numarası</label>
                            <input
                                type="text"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                placeholder="Telefon Numarası"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                            />
                        </div>
                        <div className="flex justify-between items-center pt-2">
                            <button
                                onClick={onExit}
                                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800 text-sm font-medium"
                            >
                                Çıkış Yap
                            </button>
                            <button
                                onClick={saveForm}
                                className="flex items-center gap-1.5 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm font-medium"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"></path></svg>
                                Kaydet
                            </button>
                        </div>
                    </div>
                </div>

                {selectedLocation != null && (
                    <>
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-4">
                            <h5 className="text-sm font-semibold text-gray-800 mb-3">Personel Listesi</h5>
                            <form onSubmit={(e) => { e.preventDefault(); saveAddForm(); }}>
                                <div className="flex gap-3">
                                    <input
                                        type="text"
                                        value={vestNo}
                                        onChange={(e) => setVestNo(e.target.value)}
                                        placeholder="Yelek Numarası"
                                        className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    />
                                    <button
                                        type="submit"
                                        className="flex items-center gap-1.5 px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 text-sm font-medium whitespace-nowrap"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                                        Ekle
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                    <thead className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Personel</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Yelek</th>
                                            <th className="px-4 py-3 w-12"></th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                        {personnelList.length === 0 ? (
                                            <tr><td colSpan="3" className="px-4 py-6 text-center text-gray-500 dark:text-gray-400">Herhangi bir personel eklenmedi.</td></tr>
                                        ) : personnelList.map((record) => (
                                            <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800">
                                                <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.fullName}</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.vestNo}</td>
                                                <td className="px-4 py-3 text-sm">
                                                    <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Silmek istediğinizden emin misiniz ?">
                                                        <button
                                                            className="text-red-500 hover:text-red-700 p-1"
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                                                        </button>
                                                    </ConfirmButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
